<template>
  <div class="pattern-wrap">
    <div :style="{ background: baseColor.backgroundColor }"
         class="base-color"
         @click="basePopoverOnOpen"
    >
    </div>
    <div
      :style="{ background: secondaryColor.backgroundColor }"
      class="secondary-color secondary-color_up"
      id="secondary"
    >
    </div>
    <div :style="{ background: baseColor.backgroundColor }" id="base-color" class="base-color">
    </div>
    <div
      :style="{ background: secondaryColor.backgroundColor }"
      class="secondary-color secondary-color_down"
      @click="secondaryPopoverOnOpen"
    >
    </div>
    <div
      :style="{ background: baseColor.backgroundColor }"
      class="base-color"
      @click="basePopoverOnOpen"
    >
    </div>
    <b-popover
      target="base-color"
      triggers="click blur"
      placement="left"
      ref="basePopover"
    >
      <ColorPicker
        v-on-clickaway="close"
        :colors="colorsCategories.trimColors"
        @onSelectColor="onSelectBaseColor"
      />
    </b-popover>
    <b-popover
      target="secondary"
      triggers="click blur"
      placement="left"
      ref="secondaryPopover"
    >
      <ColorPicker
        v-on-clickaway="close"
        :colors="colorsCategories.trimColors"
        @onSelectColor="onSelectSecondaryColor"
      />
    </b-popover>
  </div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker.vue';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'PatternA',
  components: {
    ColorPicker,
  },
  mixins: [clickaway],
  data () {
    return {
      baseColor: {
        backgroundColor: null
      },
      secondaryColor: {
        backgroundColor: null
      },
    };
  },
  mounted () {
    this.changeBaseColor();
    this.changeSecondaryColor();
  },
  computed: {
    baseTrimsColor () {
      return this.$store.getters['design/getBaseTrimsColor'];
    },
    secondaryTrimsColor () {
      return this.$store.getters['design/getSecondaryTrimsColor'];
    },
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },
  watch: {
    baseTrimsColor () {
      this.changeBaseColor();
    },
    secondaryTrimsColor () {
      this.changeSecondaryColor();
    }
  },
  methods: {
    basePopoverOnOpen () {
      this.$refs.basePopover.$emit('open');
    },
    secondaryPopoverOnOpen () {
      this.$refs.secondaryPopover.$emit('open');
    },
    changeBaseColor () {
      this.baseColor.backgroundColor = this.baseTrimsColor.hex;
    },
    changeSecondaryColor () {
      this.secondaryColor.backgroundColor = this.secondaryTrimsColor.hex;
    },
    onSelectBaseColor (color) {
      this.$store.commit('design/setBaseTrimColor', { color });
      this.$refs.basePopover.$emit('close');
    },
    onSelectSecondaryColor (color) {
      this.$store.commit('design/setSecondaryTrimColor', { color });
      this.$refs.secondaryPopover.$emit('close');
    },
    close () {
      this.$refs.basePopover.$emit('close');
      this.$refs.secondaryPopover.$emit('close');
    }
  }
};
</script>

<style scoped>
.pattern-wrap {
  outline: 1px solid black;
  width: 160px;
  height: 160px;
  position: relative;
}

.base-color {
  width: 100%;
  height: 20%;
  background-color: #ffffff;
}
.secondary-color {
  width: 160px;
  height: 20%;
  background-color: #cccccc;
}
</style>
